"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Forbidden = void 0;
const ApiException_1 = require("./ApiException");
class Forbidden extends ApiException_1.ApiException {
    constructor(message = 'Forbidden', data) {
        super(message, data);
    }
}
exports.Forbidden = Forbidden;
